import React from 'react';

const Commitment = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="commitement-content">
          <p>
            We operate as a responsible business, focusing on achieving ‘zero harm, zero discharge
            and zero wastage’, and thus minimising our environmental impact. We promote social inclusion across our operations to promote inclusive growth. 
            We establish management systems and processes in place to ensure our operations create sustainable value for all our stakeholders.
          </p>
        </div>

        <div className="commitement-content commitment-kits">
          <h5>KPIs</h5>
          <ul className="green-bullets">
            <li>LTIFR</li>
            <li>CSR footprint</li>
            <li>Carbon Footprint</li>
            <li>Gender diversity</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>Risks</h5>
          <ul className="green-bullets">
            <li>Health, Safety and Environment (HSE)</li>
            <li>Tailings dam stability</li>
          </ul>
          <ul className="green-bullets">
            <li>Managing relationship with stakeholders</li>
            <li>Regulatory and legal risk</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>FY2020 Update</h5>
          <ul className="green-bullets">
            <li>
            Seven fatalities occurred in the financial year; consequent commitment to increase oversight from Group Executive Committee (ExCo) to prevent future occurrences
            </li>
            <li>Average Score of 72.5% achieved in ten safety performance standards</li>
            <li>LTIFR reported at 0.67</li>
            <li>Achieved water savings of 2.99 million cubic metres (Target: 2.5 million cubic meters) </li>
            <li>c.13.83% reduction in GHG intensity over baseline of 2012</li>
            <li>Achieved energy saving of 1.92 million GJ</li>
            <li>Third-party review of tailings/ash dyke management system and development of specific improvement plan (India operations)</li>
            <li>c.105% of generated fly ash is being utilised.</li>
          </ul>
          <ul className="green-bullets">
            <li>Baseline surveys conducted across Group, BU plans aligned with findings/recommendation</li>
            <li>1,302 Nand Ghars constructed</li>
            <li>'Passion to serve' - employee volunteering online platform launched in August 2019.</li>
            <li>A standard online community grievance record/redressal software (NIVARAN) established across the group.</li>
            <li>100% new hires trained on Code of Conduct</li>
            <li>20% female representation on the Comapny FY2020 Board</li>
            <li>8.7% improvement in our campus female hiring programme</li>
            <li>Sustainability Committee constituted</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Commitment;
